/**
 * PageHeader Constants
 * Centralized constants for PageHeader flavor values
 * 
 * Note: Currently all flavors render the same structure using challengesPageStyles.combinedHeader.
 * If flavors need different configurations (styling, colors, icons) in the future,
 * consider converting this to a configuration object structure.
 */

/**
 * Header flavor constants
 * Used to determine which page variant of the header to render
 */
export const HEADER_FLAVORS = {
  CHALLENGES: 'challenges',
  FRIENDS: 'friends',
  GAME_RESULTS: 'gameResults',
} as const;







